// Shared class strings for the "paper carnet" professional grid look.
// Monochrome palette (white / black / gray) with field-friendly tap targets.
export const gridWrap =
  'overflow-x-auto rounded-xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 shadow-sm';

export const gridTable = 'min-w-full border-collapse text-sm';

export const thGroup =
  "border border-gray-200 dark:border-zinc-700 bg-stone-100 dark:bg-zinc-800 px-2.5 py-2.5 text-center font-semibold text-black dark:text-white whitespace-nowrap font-['Manrope']";

export const thCol =
  "border border-gray-200 dark:border-zinc-700 bg-stone-50 dark:bg-zinc-800/70 px-2.5 py-2.5 text-center font-medium text-neutral-700 dark:text-zinc-200 align-top font-['Manrope']";

export const thFormula =
  'block text-[10px] font-normal italic text-neutral-400 dark:text-zinc-500 mt-0.5';

export const tdCell = 'border border-gray-200 dark:border-zinc-700 align-middle p-0';

export const cellInput =
  'w-full bg-transparent px-2 py-2.5 text-sm text-black dark:text-white outline-none focus:bg-stone-100 dark:focus:bg-zinc-800 focus:ring-1 focus:ring-inset focus:ring-black/20 dark:focus:ring-white/20 text-center disabled:opacity-60 tabular-nums';

export const cellReadOnly =
  'w-full px-2 py-2.5 text-sm text-center font-medium text-neutral-600 dark:text-zinc-300 tabular-nums bg-stone-50/70 dark:bg-zinc-950/40';

export const tdSum =
  'border border-gray-200 dark:border-zinc-700 px-2.5 py-2.5 text-center font-bold text-black dark:text-white bg-stone-100 dark:bg-zinc-800 tabular-nums';
